import { useLocation } from "react-router-dom"
import { useEffect, Suspense } from "react"
import { usePostHog } from "posthog-js/react"

import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"

export function PostHogProvider({
  children,
  apiKey
}: {
  children: React.ReactNode
  apiKey: string
}) {
  if (import.meta.env.DEV) {
    return children
  }

  useEffect(() => {
    posthog.init(apiKey, {
      api_host: import.meta.env.VITE_POSTHOG_HOST,
      ui_host: "https://us.posthog.com",
      person_profiles: "always", // We want anonymous users as well.
      capture_pageview: false, // It's manual
    })
  }, [apiKey])

  return (
    <PHProvider client={posthog}>
      <SuspendedPostHogPageView />
      {children}
    </PHProvider>
  )
}

function PostHogPageView() {
  const location = useLocation()
  const posthog = usePostHog()

  // Track pageviews
  useEffect(() => {
    if (location && posthog) {
      let url = window.origin + location.pathname
      if (location.search) {
        url = url + location.search
      }

      posthog.capture("$pageview", { $current_url: url })
    }
  }, [location, posthog])

  return null
}

function SuspendedPostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageView />
    </Suspense>
  )
}
